module.exports = __webpack_public_path__ + "img/betmode_toto.192778cf.png";